import { useEffect } from 'react';
import { analyticsEnabled, GA_ID } from './analyticsConfig.js';

// Loads GA4 (gtag.js). Mirrors the source loader: it only defines gtag and
// fires gtag('js'). The initial and per-route page views come from
// trackPageView() in RouteTracker, so there is no gtag('config') here.
const GoogleAnalytics = () => {
  useEffect(() => {
    if (!analyticsEnabled || !GA_ID) return;
    if (window.gtag) return; // already injected (e.g. StrictMode double-mount)

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag('js', new Date());
  }, []);

  return null;
};

export default GoogleAnalytics;
